export const useUserInfoQueryOptions = () => ({
  staleTime: 0,
  gcTime: 1000 * 60 * 5,
});
